<template>
  <div id="app">

    <div class="popupSurvey" v-if="showpopupSurvey">
      <div class="popupSurvey__fix">
        <div class="popupSurvey__close" @click="showpopupSurvey = false">
          <img src="/LP/Ankieta-Form-14-07-2023/assets/images/close.svg" alt="close">
        </div>
        <iframe src="https://centrumwroclaw.pl/ankieta-form" frameborder="0"></iframe>
      </div>
    </div>

    <Header></Header>
    <Baner></Baner>

    <Container large="true" v-if="isSubmited">
      <Copy>
        <template v-slot:title>
          Dziękujemy!
        </template>
        <template v-slot:text>
          <p>Otrzymaliśmy Twoje zgłoszenie do Serwisu w Centrum Wrocław.</p>
          <p>Nasz Pracownik skontaktuje się z Tobą w celu potwierdzenia szczegółów wizyty. </p>
        </template>
      </Copy>
    </Container>

    <template v-else>
      <Container large="true">
        <Copy>
          <template v-slot:title>
            <!-- Przygotuj swój samochód na zimę. -->
            <!-- <br> -->
            Wybierz serwis w Auto Group Polska
          </template>
          <template v-slot:text>
            <p><strong>Autoryzowany serwis Auto Group Polska</strong> świadczy szeroką gamę usług, które pozwolą zadbać o Twój samochód w sposób profesjonalny i kompleksowy. Nasza oferta obejmuje samochody marek Volkswagen, Audi, Seat, Cupra, Škoda oraz Volkswagen Samochody Dostawcze. Nasz warsztat wykonuje naprawy niezbędne do zachowania Twojego samochodu w jak najlepszej kondycji przez cały rok. Zakres usług obejmuje przegląd techniczny, zarówno powiązany z konkretną usterką, jak i profilaktyczny, pozwalający ocenić przygotowanie do sezonu. Ponadto oferujemy naprawy mechaniczne i elektryczne oraz jakiekolwiek inne wymagające interwencji naszych specjalistów. W standardzie serwisowanie w naszym salonie obejmuje także wymianę kół i opon oraz czyszczenie i serwis klimatyzacji. Wspomniana lista obejmuje usługi podstawowe, ale <strong>autoryzowany serwis Auto Group Polska</strong> jest przygotowany do kompleksowego serwisowania samochodów z grupy VAG, również w zakresie niestandardowym. Wypełnij poniższy formularz i zarezerwuj wizytę w naszym serwisie.</p>
          </template>
        </Copy>
      </Container>

      <Container>
        <Step number="1">
          Jakiej marki jest Twój samochód:
        </Step>
        <Brands v-on:selectBrand="assignToFormData({'dealer_id':$event})" v-on:isValid="isValidHandle(1,$event)"></Brands>
      </Container>

      <Container>
        <Step number="2">
          Jakiego modelu będzie dotyczyła usługa
          <br>
          serwisowa, którą mamy dla Ciebie wykonać:
        </Step>
        <template v-slot:positioned>
          <ModelInput v-on:getModel="assignToFormData({'model':$event})"  v-on:isValid="isValidHandle(2,$event)" placeholder="Wpisz swój model"></ModelInput>
        </template>
      </Container>

      <Container>
        <Step number="3">
          Jaki jest preferowany termin, w którym chciałbyś
          <br>
          odstawić swój samochód do naszego serwisu:
        </Step>
        <template v-slot:positioned>
          <Calendar v-on:selectDate="assignToFormData({'date':$event})" v-on:selectTimeOfDay="assignToFormData({'time':$event})" v-on:isValid="isValidHandle(3,$event)"></Calendar>
        </template>
      </Container>

      <Container>
        <Step number="4">
          Czego dotyczyć będzie usługa serwisowa
          <br>
          w Centrum Wrocław:
        </Step>
        <template v-slot:positioned>
          <Services v-on:selectService="assignToFormData({'service':$event})" v-on:isValid="isValidHandle(4,$event)"></Services>
        </template>
      </Container>

      <Container>
        <Step number="5">
          Czy chciałbyś napisać coś, o czym
          <br>
          jeszcze powinniśmy wiedzieć:
        </Step>
        <template v-slot:positioned>
          <Textarea placeholder="Dodatkowe informacje" v-on:changeText="assignToFormData({'description':$event})" v-on:isValid="isValidHandle(5,$event)"></Textarea>
        </template>
      </Container>

      <Container>
        <Step number="6">
          Uzupełnij swoje dane:
        </Step>
        <template v-slot:positioned>
          <PersonalDataForm v-on:changeForm="assignToFormData($event)" v-on:clickSubmit="submit()" v-on:isValid="isValidHandle(6,$event)" :showSubmit="!isSubmited"></PersonalDataForm>
        </template>
      </Container>
      <BottomBar :hidden="isTryingSubmit && getFirstError.length > 0">
        {{ getFirstError }}
      </BottomBar>
    </template>

  </div>
</template>

<script>
import Header from './components/Header'
import Baner from './components/Baner'
import Copy from './components/Copy'
import Container from './components/Container'
import Step from './components/Step'
import BottomBar from './components/BottomBar'

import Brands from './components/Brands'
import Services from './components/Services'
import ModelInput from './components/ModelInput'
import Calendar from './components/Calendar'
import Textarea from './components/Textarea'
import PersonalDataForm from './components/PersonalDataForm'

import axios from 'axios';

export default {
  name: 'app',
  components: {
    Baner,
    Copy,
    Container,
    Step,
    Brands,
    ModelInput,
    Services,
    Calendar,
    Textarea,
    PersonalDataForm,
    Header,
    BottomBar
  },
  data(){
    return {
      validSteps:{
        1:false,
        2:false,
        3:false,
        4:false,
        5:false,
        6:false
      },
      validErrorMessages:{
        1:"Wybierz markę w pierwszym kroku",
        2:"Wpisz swój model w drugim kroku",
        3:"Wybierz dogodną datę oraz porę dnia",
        4:"Wybierz typ wizyty w kroku czwartym",
        5:false,
        6:"Uzupełnij swoje dane oraz wyraź zgodę w kroku szóstym"
      },
      isTryingSubmit:false,
      isSubmited:false,
      showpopupSurvey: false,
      formData:{
        // test:1,
        campaign_id:8,
        department_id:3,
        origin_id:5,
        url:window.location.href?window.location.href:'https://centrumwroclaw.pl/umow-serwis/'
      },
      formDataToDescription:{
        model:{
          type:'text',
          text:'Model'
        },
        service:{
          type:'array',
          text:'Wybrane usługi serwisowe'
        },
        date:{
          type:'text',
          text:'Preferowany termin wizyty'
        },
        time:{
          type:'text',
          text:'Preferowana pora dnia'
        }
      }
    }
  },
  computed:{
    getFirstError:{
      get(){
        let errorKey = Object.keys(this.validSteps).find(e => this.validSteps[e] == false && this.validErrorMessages[e] != false);
        return errorKey? this.validErrorMessages[errorKey]:''
      }
    }
  },
  methods:{
    assignToFormData(value){
      this.formData = {
        ...this.formData,
        ...value
      }
    },
    isValidHandle(step,val){
      this.validSteps[step] = val
    },
    assignFormDataToDescription(){

      if(this.formData.description){
        this.formData.description = `Dodatkowe informacje: ${this.formData.description},`;
      }

      this.formData.description += Object.keys(this.formDataToDescription).map( e => {
        if(this.formData[e]){

          let field = ` ${this.formDataToDescription[e].text}: `;

          switch (e.type) {
            case 'array':
            field += `${this.formData[e].join(', ')} `
            break;

            default:
            field += `${this.formData[e]}, `
            break;
          }

          return field;

        }
      }).join('')

    },
    async submit(){
      grecaptcha.ready(async () => {
        grecaptcha.execute('6LdfEVopAAAAAIIhGirCfCTzSZZyTRd-VT_C6-bb', { action: 'submit' }).then(async (token) => {
          this.isTryingSubmit = true;
          if(!this.getFirstError){
            this.assignFormDataToDescription();
            let formState = { ...this.formData, token };
            const response = await axios.post('https://centrumwroclaw.pl/send.php',formState);
            if(response.data.status == 200){
              this.isSubmited = true;
              window.location.href = "/serwis/dziekujemy/";
              // this.showpopupSurvey = true;
            }else{
              window.alert('Błąd wysyłki formularza. Sprawdź połączenie z siecią')
            }
          }
        });
      });

    }
  }
}
</script>

<style lang="scss">

@import url('./assets/fonts/stylesheet.css');

html,body{
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-family: 'Montserrat';
  padding-bottom: 10vh;
}
p{
  line-height: 1.4em;
}
*,*::after,*::before{
  box-sizing: border-box;
}

</style>
